"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var React = _interopRequireWildcard(require("react"));

var PropTypes = _interopRequireWildcard(require("prop-types"));

var _Hidden = _interopRequireDefault(require("@material-ui/core/Hidden"));

var Hidden =
/*#__PURE__*/
function (_React$PureComponent) {
  (0, _inherits2.default)(Hidden, _React$PureComponent);

  function Hidden() {
    (0, _classCallCheck2.default)(this, Hidden);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Hidden).apply(this, arguments));
  }

  (0, _createClass2.default)(Hidden, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          lgDown = _this$props.lgDown,
          lgUp = _this$props.lgUp,
          mdDown = _this$props.mdDown,
          mdUp = _this$props.mdUp,
          only = _this$props.only,
          smDown = _this$props.smDown,
          smUp = _this$props.smUp,
          xlDown = _this$props.xlDown,
          xlUp = _this$props.xlUp,
          xsDown = _this$props.xsDown,
          xsUp = _this$props.xsUp;
      return React.createElement(_Hidden.default, {
        lgDown: lgDown,
        lgUp: lgUp,
        mdDown: mdDown,
        mdUp: mdUp,
        only: only,
        smDown: smDown,
        smUp: smUp,
        xlDown: xlDown,
        xlUp: xlUp,
        xsDown: xsDown,
        xsUp: xsUp
      }, children);
    }
  }]);
  return Hidden;
}(React.PureComponent);

Hidden.defaultProps = {
  children: null,
  lgDown: false,
  lgUp: false,
  mdDown: false,
  mdUp: false,
  smDown: false,
  smUp: false,
  xlDown: false,
  xlUp: false,
  xsDown: false,
  xsUp: false
};
Hidden.propTypes = {
  children: PropTypes.any,

  /**
   * If true, screens this size and down will be hidden.
   */
  lgDown: PropTypes.bool,

  /**
   * If true, screens this size and up will be hidden.
   */
  lgUp: PropTypes.bool,

  /**
   * If true, screens this size and down will be hidden.
   */
  mdDown: PropTypes.bool,

  /**
   * If true, screens this size and up will be hidden.
   */
  mdUp: PropTypes.bool,

  /**
   * Hide the given breakpoint(s).
   */
  only: PropTypes.oneOfType([PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']), PropTypes.arrayOf(PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']))]),

  /**
   * If true, screens this size and down will be hidden.
   */
  smDown: PropTypes.bool,

  /**
   * If true, screens this size and up will be hidden.
   */
  smUp: PropTypes.bool,

  /**
   * If true, screens this size and down will be hidden.
   */
  xlDown: PropTypes.bool,

  /**
   * If true, screens this size and up will be hidden.
   */
  xlUp: PropTypes.bool,

  /**
   * If true, screens this size and down will be hidden.
   */
  xsDown: PropTypes.bool,

  /**
   * If true, screens this size and up will be hidden.
   */
  xsUp: PropTypes.bool
};
var _default = Hidden;
exports.default = _default;